export default {
  name: "TopHeader",

  methods: {
    toggleNav() {
      window.sette.emitter.$emit("NavMenu.toggle");
    }
  }
};